export default "__VITE_ASSET__5RcPSJR1__"